import { isEmpty } from 'lodash';
import { hideLoader, showLoader } from 'actions/loader';
import requester from 'utils/requester';
import api from 'config/api';
import { GRID_MAX_SIZE as ITEMS_PER_REQUEST } from 'config';
import { selectContinueWatching } from 'reducers/continue-watching/selectors';
import * as types from './types';
import Platform from 'platform';
import { CONTENT_TYPES } from 'constants/content-types';

const paramsByType = {
  catchup: {
    url: `${api.host}${api.endpoints.searchVod}`,
    appendParams: false,
    params: {
      f_userData: 'bookmarks',
      type: 'VOD_ASSET',
      'f_metadata.contentType': 'EPG_EVENT',
      f_deviceType: Platform.getDeviceType(),
      f_epgEventState: 'CATCHUP',
      searchMetadata: true,
      detailed: true,
      includeVod: true,
      size: ITEMS_PER_REQUEST,
    },
  },
  vod: {
    url: `${api.host}${api.endpoints.searchVod}`,
    appendParams: false,
    params: {
      f_userData: 'bookmarks',
      type: 'ALL',
      'f_metadata.contentType': 'MOVIE',
      f_deviceType: Platform.getDeviceType(),
      searchMetadata: true,
      detailed: true,
      includeVod: true,
      size: ITEMS_PER_REQUEST,
    },
  },
  channel: {
    url: `${api.host}${api.endpoints.searchChannel}`,
    params: {
      f_userData: 'recentlyWatched',
      detailed: true,
      includeVod: true,
      size: ITEMS_PER_REQUEST,
    },
  },
};

export const fetchContinueWatching = (type) => async (dispatch) => {
  try {
    const queryParams = paramsByType[type];

    if (!queryParams) return;

    dispatch(showLoader());
    dispatch({ type: types.FETCH, payload: { type } });

    const { content } = await requester({
      method: 'get',
      ...queryParams,
    });

    dispatch({
      type: types.FETCH_SUCCESS,
      payload: { content, type },
    });
  } catch (error) {
    console.error(error);
    dispatch({
      type: types.FETCH_ERROR,
      payload: { error, type },
    });
  } finally {
    dispatch(hideLoader());
  }
};

export const loadExtraContinueWatchingItems = (type) => async (dispatch, getState) => {
  try {
    const continueWatching = selectContinueWatching(getState())[type];
    const { isOnLazyLoad, isAllItemsWereLoaded } = continueWatching;
    const page = continueWatching.page + 1;

    if (isOnLazyLoad || isAllItemsWereLoaded) return;

    const queryParams = paramsByType[type];

    dispatch({ type: types.LOAD_EXTRA_ITEMS, payload: { type } });

    const { content } = await requester({
      method: 'get',
      url: queryParams.url,
      params: { ...queryParams.params, page },
    });

    if (isEmpty(content)) {
      dispatch({ type: types.LOAD_EXTRA_ITEMS_COMPLETED, payload: { type } });
    } else {
      dispatch({
        type: types.LOAD_EXTRA_ITEMS_SUCCESS,
        payload: { type, content, page },
      });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: types.LOAD_EXTRA_ITEMS_ERROR, payload: { type, error } });
  }
};

export const removeItem =
  ({ type, item }) =>
  async (dispatch) => {
    try {
      const { id } = item;
      const apiEndPointByAssetType =
        item.type === CONTENT_TYPES.TV_SERIES
          ? api.endpoints.seriesBookmark
          : api.endpoints.assetBookmark;

      if (type === 'channel') {
        await requester({
          method: 'delete',
          url: `${api.host}${api.endpoints.recentlyWatchedChannels}/${id}`,
        });
        dispatch({ type: types.REMOVE_ITEM, payload: { type, id } });
      } else {
        await requester({
          method: 'delete',
          url: `${api.host}${apiEndPointByAssetType}/${id}`,
        });
        dispatch({ type: types.REMOVE_ITEM, payload: { type, id } });
      }
    } catch (error) {
      console.error(error);
    }
  };

export const resetAllContinueWatchingData = () => ({
  type: types.RESET_ALL_DATA,
});
